/**
 * RG Collection Showcase JavaScript - Tab switching logic
 */

class RGCollectionTabs {
    constructor(container) {
        this.container = container;
        this.tabs = container.querySelectorAll('[data-rg-tab]');
        this.panels = container.querySelectorAll('[data-rg-panel]');

        this.init();
    }

    init() {
        this.tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const tabIndex = parseInt(tab.dataset.rgTab);
                this.switchToTab(tabIndex);
            });
        });

        // Initialize Add to Cart functionality
        this.container.querySelectorAll('[data-rg-add-to-cart]').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const variantId = btn.dataset.variantId;
                this.addToCart(variantId, btn);
            });
        });
    }

    switchToTab(index) {
        // Remove active class from all tabs and panels
        this.tabs.forEach(t => t.classList.remove('rg-active'));
        this.panels.forEach(p => p.classList.remove('rg-active'));

        // Add active class to selected tab and panel
        this.tabs[index].classList.add('rg-active');
        this.panels[index].classList.add('rg-active');
    }

    async addToCart(variantId, btn) {
        if (!variantId) return;

        const originalText = btn.innerHTML;
        btn.innerHTML = '<span class="material-icons-outlined rg-spin">sync</span> AGREGANDO...';
        btn.disabled = true;

        try {
            // 1. Theme-Specific Sections
            const sectionsToUpdate = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-live-region-text', 'main-cart-items'];

            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1
                    }],
                    sections: sectionsToUpdate
                })
            });

            if (response.ok) {
                const data = await response.json();

                // DISPATCH CUSTOM EVENT FOR TRACKING
                // Proven logic from rg-catalog-grid.js
                const productCard = btn.closest('[data-product-id]');
                if (productCard) {
                    const trackingData = {
                        product_id: productCard.dataset.productId,
                        variant_id: variantId,
                        product_name: productCard.dataset.productName,
                        product_price: parseFloat(productCard.dataset.productPrice) || 0,
                        product_category: productCard.dataset.productCategory || 'Collection',
                        quantity: 1,
                        currency: window.Shopify?.currency?.active || 'COP'
                    };

                    document.dispatchEvent(new CustomEvent('product:addedToCart', {
                        detail: trackingData,
                        bubbles: true
                    }));
                }

                // 2. THEME INTEGRATION: PubSub (Native Event Bus)
                if (window.publish && window.PUB_SUB_EVENTS) {
                    window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                        source: 'rg-collection-showcase',
                        cartData: data
                    });
                }

                // 3. THEME INTEGRATION: Direct Component Call
                const miniCart = document.querySelector('mini-cart');
                if (miniCart) {
                    if (typeof miniCart.renderContents === 'function') {
                        miniCart.renderContents(data);
                    }

                    if (typeof miniCart.open === 'function') {
                        miniCart.open();
                    } else if (miniCart.querySelector('details')) {
                        const details = miniCart.querySelector('details');
                        if (!details.hasAttribute('open')) details.setAttribute('open', '');
                    }
                }

                // 4. Fallback: Manual DOM Updates for Icon Bubbles
                if (data.sections) {
                    if (data.sections['cart-icon-bubble']) {
                        const cartIconBubble = document.getElementById('cart-icon-bubble') || document.querySelector('.cart-icon-bubble');
                        if (cartIconBubble) cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
                    }

                    const fetchCart = await fetch(window.Shopify.routes.root + 'cart.js');
                    const cartData = await fetchCart.json();
                    document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(el => {
                        el.innerText = cartData.item_count;
                        el.closest('.cart-count-bubble')?.classList.remove('hidden');
                    });
                }

                // 5. UX: Haptics & Feedback
                if (navigator.vibrate) navigator.vibrate(50);

                btn.innerHTML = '<span class="material-icons-outlined">check_circle</span> ¡LISTO!';
                btn.classList.add('rg-success');

            } else {
                throw new Error('Network response was not ok');
            }
        } catch (error) {
            console.error('Error adding to cart:', error);
            btn.innerHTML = '<span class="material-icons-outlined">error</span> ERROR';
        } finally {
            setTimeout(() => {
                btn.innerHTML = originalText;
                btn.disabled = false;
                btn.classList.remove('rg-success');
            }, 3000);
        }
    }
}

// Initialize all collection tabs instances
document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('[data-rg-tabs]');
    containers.forEach(container => {
        const tabsContainer = container.closest('.rg-collection-tabs');
        if (tabsContainer) {
            new RGCollectionTabs(tabsContainer);
        }
    });
});

// Reinitialize on Shopify theme editor section load
if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const tabsContainer = event.target.querySelector('.rg-collection-tabs');
        if (tabsContainer) {
            new RGCollectionTabs(tabsContainer);
        }
    });
}
